import React from "react";

const BharatAbroadAd = () => {
  return (
    <>
      <div className="card ba-ad-card mb-4">
        <div className="card-body">
          <div className="row align-items-center">
            {/* Left Image */}
            <div className="col-md-2 text-center mb-3 mb-md-0">
              <img
                src="https://ayg.s3.us-east-2.amazonaws.com/BA_whatsapp.png"
                alt="Bharat Abroad"
                className="img-fluid"
                style={{ height: "auto" }}
              />
            </div>

            {/* Right Content */}
            <div className="col-md-10 text-center text-md-start">
              <p className="ba-subtext">
                Bharat Abroad is a community-focused initiative dedicated to
                highlighting and strengthening Bharat's cultural and spiritual
                presence across the global diaspora through storytelling, event
                engagement, and collaboration with nonresident Bharatiya
                organizations.
              </p>

              <a
                href="https://chat.whatsapp.com/LNfGI3UFWbt69VeUbBoxLj"
                target="_blank"
                rel="noopener noreferrer"
                className="btn ba-btn mt-2"
              >
                Join WhatsApp Community
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Internal Styles */}
      <style>{`
        .ba-ad-card {
          border: none;
          border-radius: 16px;
          background: linear-gradient(135deg, #0f2027, #203a43, #2c5364);
          color: #fff;
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
          overflow: hidden;
        }

        .ba-ad-img {
          max-height: 160px;
          object-fit: contain;
        }

        .ba-title {
          font-weight: 700;
          font-size: 1.6rem;
        }

        .ba-subtext {
          font-size: 0.95rem;
          opacity: 0.9;
        }

        .ba-btn {
          background: #25D366;
          color: #fff;
          border-radius: 30px;
          padding: 8px 18px;
          font-weight: 600;
          transition: all 0.3s ease;
        }

        .ba-btn:hover {
          background: #1ebe5d;
          transform: scale(1.05);
        }
      `}</style>
    </>
  );
};

export default BharatAbroadAd;
